module.exports = __webpack_public_path__ + "img/battery-charging-01.4ce767b7.svg";